import styled, { css } from "styled-components";

import { Tabs, TabList } from "@similarweb/ui-components";

export const FullWidthTabs = styled(Tabs)`
    width: 100%;
`;

export const FullWidthTabList = styled(TabList)`
    width: 100%;
`;

export const ModelComparisonWrapper = styled.div<{ $hideGranularitySwitcher: boolean }>`
    ${({ $hideGranularitySwitcher }) =>
        $hideGranularitySwitcher &&
        css`
            .swichers-container {
                visibility: hidden;
            }
        `};
`;
